import React from 'react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  const riceSteps = [{
    letter: 'R',
    title: 'Rol',
    desc: 'Le asignas una personalidad y nivel de experiencia específico. La IA sabe exactamente quién es.'
  }, {
    letter: 'I',
    title: 'Instrucción',
    desc: 'La tarea exacta con verbos de acción claros. Sin ambigüedad. Sin resultados genéricos.'
  }, {
    letter: 'C',
    title: 'Contexto',
    desc: 'Defines tu audiencia y el problema que resuelves. La IA entiende para quién escribe.'
  }, {
    letter: 'E',
    title: 'Ejecución',
    desc: 'El tono, el formato y la estructura final. Controlas el resultado antes de que se escriba.'
  }];
  return <section className="py-28 px-6 bg-dark text-center" data-id="element-177">
      <div className="max-w-[900px] mx-auto" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-179">
          <span className="inline-block text-orange text-xs font-bold tracking-[2px] uppercase mb-4" data-id="element-180">
            La Solución
          </span>
          <h2 className="text-[clamp(28px,4vw,48px)] font-black mb-4 max-w-[700px] mx-auto text-white" data-id="element-181">
            El Método <span className="text-orange" data-id="element-182">R.I.C.E.</span>
          </h2>
          <p className="text-lg text-[#AAAAAA] max-w-[600px] mx-auto mb-[60px]" data-id="element-183">
            La fórmula de 4 pilares que transforma ChatGPT en tu equipo de
            marketing personal — y hace que la IA escriba con tu voz.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-[60px]" data-id="element-184">
          {riceSteps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: i * 0.1
        }} className="bg-cardBg border border-border rounded-2xl p-8 text-center relative overflow-hidden transition-all duration-300 hover:border-orange hover:-translate-y-1 group" data-id="element-185">
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-orange to-gold" data-id="element-186" />
              <div className="text-[56px] font-black text-orange leading-none mb-2" data-id="element-187">
                {step.letter}
              </div>
              <div className="text-[20px] font-bold mb-3 text-white" data-id="element-188">
                {step.title}
              </div>
              <div className="text-[14px] text-[#888] leading-[1.6]" data-id="element-189">
                {step.desc}
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-orange to-[#FF8C00] rounded-2xl p-10 max-w-[700px] mx-auto text-center" data-id="element-190">
          <h3 className="text-[24px] font-black mb-3 text-white" data-id="element-191">
            ¿El resultado?
          </h3>
          <p className="text-[16px] text-white/90 leading-[1.7]" data-id="element-192">
            IA que no suena a robot — suena a ti.
            <br data-id="element-193" />
            Contenido que conecta, convence y convierte.
            <br data-id="element-194" />
            Producido en minutos, no en horas.
          </p>
        </motion.div>
      </div>
    </section>;
}